import { useState } from "react";
import useApi from "../../api";
import { NXDelete, NXEyes } from "../../icons";
import { useDeleteConfirmation } from "../common";
import GenericSelectableTable from "../selectableTable";
import { toast } from "react-toastify";
import StockReservationDetailsView from "../../pages/stocks/stockReservationDetails";


interface StockTableProps {
    data: any;
    refresh: ()=>void;
}

function StockReservationTable({data, refresh}:StockTableProps) {
  const [stockReservationId, setStockReservationId] = useState<any>(null)
  const {handleDelete}  = useDeleteConfirmation()
  const api = useApi()

  const columns = [
    { header: "ID", key: "id", render:(item:any)=>(
      <div className="text-base-300 text-sm">
        #ID {item.node.dbId}
      </div>
    )},
    { header: "Warehouse", key: "node.stock.warehouse.name", },
    { header: "Variant", key: "node.stock.productVariant.displayName", },
    { header: "Purpose", key: "node.purpose", },
    { header: "reserved", key: "node.quantity", },
    { header: "Action", key: "", render: (item:any)=>(
      <div className="flex gap-1 items-center">
        <button onClick={() => setStockReservationId(item.node.dbId)}>
          <NXEyes className="text-primary-400" />
        </button>
        <button
          className="p-1"
          onClick={() => {
            handleDelete(
              item.id,
              "Stock",
              api.deleteStock,
              refresh
            );
          }}
        >
          <NXDelete className="text-red-600" />
        </button>
      </div>
    )},

  ]
  const bullkActionButtons = [
    {
      label: 'Delete Selected',
      onClick: (selectedItems:any) => {
        toast.success(`Delete items: ${Array.from(selectedItems)}`);
        // Implement delete logic here
      },
    },
    {
      label: 'Export Selected',
      onClick: (selectedItems:any) => {
        toast.success(`Export items: ${Array.from(selectedItems)}`);
        // Implement export logic here
      },
    },
  ];
  return (
    <div>
      <div className="overflow-x-auto">
        <GenericSelectableTable columns={columns} data={data} bullkActionButtons={bullkActionButtons}/>
      </div>
      {stockReservationId &&  <StockReservationDetailsView instance={stockReservationId} isOpen={stockReservationId ? true : false} onClose={()=>setStockReservationId(null)} refresh={refresh} /> }

    </div>
  )
}

export default StockReservationTable